import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID } from '@angular/core';
import { NoPreloading, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { APP_ROUTES } from './app.routes';
import { InterceptorService } from './core/http/interceptor.service';
import { environment } from '../environments/environment';
import { PasoSolicitudSync } from './features/solicitud/shared/state/paso-solicitud.sync';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      APP_ROUTES,
      withPreloading(NoPreloading),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    { provide: LOCALE_ID, useValue: 'es-CO' },
    // Origination steps that did not reach the backend: drained at start and when the connection returns.
    { provide: APP_INITIALIZER, multi: true, deps: [PasoSolicitudSync], useFactory: (pasos: PasoSolicitudSync) => () => pasos.iniciarRecuperacion() },
  ],
};
